import { render, staticRenderFns } from "./BadgeAddon.vue?vue&type=template&id=99f80c0e"
import script from "./BadgeAddon.vue?vue&type=script&lang=js"
export * from "./BadgeAddon.vue?vue&type=script&lang=js"
import style0 from "./BadgeAddon.vue?vue&type=style&index=0&id=99f80c0e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports